import { PublicClientApplication } from '@azure/msal-browser';

/**
 * This msaInstance is used to authenticate the user and get the token to call the backend.
 * It is exported from its own file, because before it was defined in the bootstrap.tsx file.
 * But as the FetchService class imports it, it created a circular dependency, breaking the HMR.
 */
const msalInstance = new PublicClientApplication({
  auth: {
    clientId: process.env.AAD_CLIENT_ID || '',
    authority: 'https://login.microsoftonline.com/a289d6c2-3b1f-4bc4-8fa0-6866ff300052', // This is a URL (e.g. https://login.microsoftonline.com/{your tenant ID})
    redirectUri: process.env.AAD_REDIRECT_URI,
  },
  cache: {
    cacheLocation: 'sessionStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
});

export { msalInstance };
